import containsImplicitGroupMembers from './containsImplicitGroupMembers';
import getReadWriteRecipientViewState from 'owa-recipient-common/lib/utils/getReadWriteRecipientViewState';
import ReadWriteRecipientViewState from 'owa-recipient-common/lib/store/schema/ReadWriteRecipientViewState';

/**
 * Returns an array of ReadWriteRecipientViewState containing recipient and implicit group members.
 */
export default function(item: ReadWriteRecipientViewState): ReadWriteRecipientViewState[] {
    if (containsImplicitGroupMembers(item)) {
        return item.persona.Members.map(member =>
            getReadWriteRecipientViewState(
                {
                    EmailAddress: member,
                },
                true,
                null
            )
        );
    } else {
        return [getReadWriteRecipientViewState(item.persona, true, null)];
    }
}
